import { WordObject } from '../../interfaces/word-object/WordObject';
import { ITEM_TYPES } from '../../item/item-types';
import { MESSAGE_TYPES } from '../../item/message-types';
import { AbstractChatMessage } from './abstract-chat-message';
import { DictionaryContent } from './dictionary-content-interface';
import { InteractiveChatJourneyType } from './interactive-chat-journey-type';
import { LessonContentType } from './lesson-content-type';
import { MessageData } from './message-data';

export class LessonMessage extends AbstractChatMessage {
    content: LessonContentType;
 
    constructor(){
        super()
        this.setType(MESSAGE_TYPES.Lesson)
    }
}
